import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { AuthService } from '../auth.service';
import { GlobalService } from 'src/app/shared/services/global.service';

@Injectable({ providedIn: 'root' })
export class CheckinGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private identityService: IdentityService,
    private globalService: GlobalService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {


      this.authService.autoLogin(1);
      if (this.identityService.authenticated != null && this.identityService.authenticated == true)
      {  
        if ((this.identityService.hasCheckIn() || this.identityService.hasBase() || this.identityService.hasAdmin() ||
        this.identityService.hasSuperAdmin() || this.identityService.hasLeader()))
          return true;
        return false;
      }
      else
      { 
    return this.authService.user.pipe(
      take(1),
      map((user) => {
        const isAuth = !!user;
        if (
          isAuth &&
          user &&
          ((user.roles.indexOf('Check-in') >= 0 ||
            user.roles.indexOf('Base') >= 0 ||
            user.roles.indexOf('Admin') >= 0 ||
            user.roles.indexOf('Super Admin') >= 0 ||
            this.identityService.permissions.indexOf('Leader') >= 0))
        )
          return true; // Includes Admin and Super Admin
        if (isAuth) {
          this.router.navigate(['/unauthorized']);
          return false;
        } else {
          const [returnUrl, returnQueryParams] = state.url.split('?');
          this.router.navigate([this.globalService.subdomain + '/login'], {
            queryParams: { returnUrl, returnQueryParams },
          });
          return false;
        }
      })
    );
  }
}
}
